import { Text } from '@querodelivery/uni-react';
import styles from './ranking-empty-state.module.scss';
import EmptyStateIcon from '@/Assets/svg/empty-directory.svg';

type RankingEmptyStateProps = {
  title: string;
  description: string;
};

export const RankingEmptyState = ({
  title,
  description,
}: RankingEmptyStateProps) => (
  <div className={styles.emptyState}>
    <img src={EmptyStateIcon} alt="" width={72} />
    <Text variant="headingSm" tone="supporting" fontWeight="bold">
      {title}
    </Text>
    <Text variant="bodySm" tone="supporting">
      {description}
    </Text>
  </div>
);
